import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '../../store';
import { AlertService } from '../../services/alert.service';
import {
    CallLogsSearchParams,
    defaultCallLogsSearchParams
} from '../../data-types/search-params';
import { ReplaySubject, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { TwilioService } from '../../services/twilio.service';
import { AlertConfirmable } from '../../decorators/alert-confirmable.decorator';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-user-call-log',
    templateUrl: './user-call-log.component.html',
    styleUrls: ['./user-call-log.component.scss'],
    animations: [
        trigger('fadeIn', [
            state('void', style({ opacity: '0' })),
            transition('void <=> *', [
                animate('150ms ease-in')
            ]),
        ]),
        trigger('fadeOut', [
            state('*', style({ opacity: '1' })),
            transition('* <=> void', [
                animate('100ms ease-out')
            ]),
        ])
    ]
})
export class UserCallLogComponent implements OnInit, OnDestroy
{
    @Input() userId: string = null;

    destroy$ = new Subject<void>();
    subs$ = new ReplaySubject();

    callParams: CallLogsSearchParams = { ...defaultCallLogsSearchParams };
    callLogs: Array<any>;

    sound = {};
    playing = null;
    audio = null;

    constructor(
        private store: Store,
        private alertService: AlertService,
        public twilioService: TwilioService
    )
    {
    }

    ngOnInit(): void
    {
        this.callParams.customerId = this.userId;
        this.callHistoryList();
    }

    callHistoryList()
    {
        this.subs$.next(this.twilioService
            .getCallHistoryByCId(
                this.callParams.page * this.callParams.limit,
                this.callParams.limit,
                this.callParams.customerId,
                this.callParams.direction
            )
            .pipe(takeUntil(this.destroy$), first())
            .subscribe((result: { list: Array<any>, totalRecords: number }) =>
            {
                this.callLogs = [];
                if (result.list.length > 0) {
                    this.callLogs = result.list;
                }
                if (result.totalRecords) {
                    this.callParams.pages = Math.ceil(result.totalRecords / this.callParams.limit);
                    this.callParams.totalRecords = result.totalRecords;
                    this.callParams.pageArray = [];
                    for (let i = 0; i < this.callParams.pages; i++) {
                        this.callParams.pageArray.push(i);
                    }
                }
            })
        );
    }

    @AlertConfirmable({ title: "Do you want to make a call to customer?" })
    makeACallLog(callObjet: any)
    {
        if (!this.twilioService.isLineBusy) {
            this.twilioService.startOutboundCall(callObjet.direction === 'out' ? callObjet.callTo : callObjet.callFrom);
        } else {
            this.alertService.error(['Line is busy, please nicely finish ongoing conversation before starting the new one.']);
        }
    }

    initPlaybackRecord(callRecord: any)
    {
        if (this.audio) {
            this.audio.pause();
        } else {
            this.audio = document.createElement("audio");
            this.audio.setAttribute("preload", "auto");
            this.audio.setAttribute("controls", "none");
            this.audio.style.display = "none";
            document.body.appendChild(this.audio);
        }

        this.audio.src = callRecord.mediaFile + ".mp3";
        this.audio.play();
        this.playing = callRecord.sId;
    }

    stopPlayback()
    {
        this.audio.pause();
        this.playing = null;
    }

    ngOnDestroy(): void
    {
        this.destroy$.next();
        this.destroy$.complete();
        this.subs$.complete();
    }
}
